import { render, staticRenderFns } from "./TraxUiAjaxSimpleTable.vue?vue&type=template&id=7e4a0c2f"
import script from "./TraxUiAjaxSimpleTable.vue?vue&type=script&lang=js"
export * from "./TraxUiAjaxSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports